import { ReactComponent } from './no-card.svg';
import { createIconFromSvg } from '../icons';

export const NoCard = createIconFromSvg(ReactComponent);
